module.exports = __webpack_public_path__ + "img/Asset 64.a50f2bac.svg";